import ControlledCheckbox from "./ControlledCheckbox";
import ControlledCreatableInput from "./ControlledCreatableInput";
import ControlledDatePicker from "./ControlledDatePicker";
import ControlledDateTimePicker from "./ControlledDateTimePicker";
import ControlledDropdown from "./ControlledDropdown";
import ControlledInput from "./ControlledInput";
import ControlledPassword from "./ControlledPassword";
import ControlledTextArea from "./ControlledTextArea";
import FieldGroup from "./FieldGroup";
import Form from "./Form";

Form.Input = ControlledInput;
Form.Dropdown = ControlledDropdown;
Form.Checkbox = ControlledCheckbox;
Form.DatePicker = ControlledDatePicker;
Form.DateTimePicker = ControlledDateTimePicker;
Form.TextArea = ControlledTextArea;
Form.CreatableInput = ControlledCreatableInput;
Form.Password = ControlledPassword;
Form.FieldGroup = FieldGroup;

export default Form;
